import Marquee from "react-fast-marquee";

const WORDS = ["MALWARE", "PRIVACY", "CHEAT DETECTION", "REVERSE PROXY", "CLOUD", "THEFT PREVENTION", "EDGE NETWORK"];

export default function MarqueeSection() {
  return (
    <section className="relative py-16 border-y border-white/10 bg-[#07070E] overflow-hidden" data-testid="marquee-section">
      <Marquee speed={40} gradient={false} className="overflow-hidden">
        {WORDS.map((w, i) => (
          <span key={i} className="flex items-center">
            <span
              className={`font-display font-900 text-6xl sm:text-7xl lg:text-8xl tracking-tighter px-8 ${
                i % 2 === 0 ? "text-outline" : "text-outline-cyan"
              }`}
            >
              {w}
            </span>
            <span className="text-[#22D3EE] text-4xl px-2">✦</span>
          </span>
        ))}
      </Marquee>
    </section>
  );
}
